export default __webpack_public_path__ + "static/media/VISA.7715beaba5dc93b9577d1c4a65fcc017.webp";